import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";

const KEY = "gi_cookie_ack_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { setShow(!localStorage.getItem(KEY)); } catch { setShow(true); }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch {}
    window.dispatchEvent(new Event("cookie-consent"));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4 pointer-events-none" data-testid="cookie-banner">
      <div className="pointer-events-auto max-w-3xl mx-auto rounded-xl border border-line bg-surface backdrop-blur-xl shadow-float p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-9 h-9 rounded-lg bg-brand-soft border border-brand/30 flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-brand" />
          </div>
          <p className="text-sm text-body leading-relaxed">
            We use a single essential <span className="text-ink font-medium">session cookie</span> to keep you signed in and to secure the app. We don't use advertising or tracking cookies. See our{" "}
            <a href="/privacy" className="text-brand hover:underline">Privacy Policy</a>.
          </p>
        </div>
        <button
          data-testid="cookie-accept-button"
          onClick={accept}
          className="w-full sm:w-auto shrink-0 px-5 py-2.5 rounded-xl bg-brand text-onbrand text-sm font-semibold hover:bg-brand-hover transition-colors duration-200"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
